import {
  getSubscriptionAmountExcludingContribution,
  type SubscriptionAmountSource,
} from './processingFeeContribution';

type Amount = { amount?: number | null };

export type SubscriptionCouponBaseInput = SubscriptionAmountSource & {
  fees?: Amount[] | null;
  orderBumps?: (Amount & { billingType?: string | null })[] | null;
};

const total = (rows: Amount[] | null | undefined) =>
  (rows ?? []).reduce((sum, row) => sum + (row.amount ?? 0), 0);

// The stored amount carries the recurring fees, recurring bumps and processing fee contribution,
// but Stripe puts a percent coupon on the product and its recurring options only (get-subscription-items.js).
export function getSubscriptionCouponBase(subscription: SubscriptionCouponBaseInput): number {
  const recurringBumps = (subscription.orderBumps ?? []).filter(
    bump => bump.billingType === 'recurring',
  );
  return (
    getSubscriptionAmountExcludingContribution(subscription) -
    total(subscription.fees) -
    total(recurringBumps)
  );
}
